import Home from 'src/components/Home';
import HomeHistorical from 'src/components/HomeHistorical';
import ShowDetail from 'src/components/ShowDetail';
import FullIndex from 'src/components/FullIndex';

export default [
    {
        path: '/',
        meta: { auth: false },
        name: 'home',
        component: Home,
    },
    {
        path: '/historical',
        meta: { auth: false },
        name: 'historical',
        component: HomeHistorical,
    },
    {
        path: '/show/:show',
        meta: { auth: false },
        name: 'showDetail',
        component: ShowDetail,
    },
    {
        path: '/full-index',
        meta: { auth: false },
        name: 'fullIndex',
        component: FullIndex,
    },
];
